var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside"},[_c('Logo'),_c('Title'),_c('Description'),_c('Contacts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }